import { render, staticRenderFns } from "./recorded.vue?vue&type=template&id=0cb5febc&scoped=true"
import script from "./recorded.vue?vue&type=script&lang=js"
export * from "./recorded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5febc",
  null
  
)

export default component.exports